import { ProductItemInterface, StoreInterface } from "@/assets/interfaces";
import { isValidHexCode } from "@/assets/js/utils/functions";
import { generateComplementaryHexColor3 } from "@/assets/js/utils/functions";
import { hexToRgb } from "@/assets/js/utils/functions";
import useAnalytics, { PAGE_TYPE } from "@/components/hooks/analytics";
import { useModals } from "@/components/hooks/useModals";
import { useEffect, useState } from "react";
import { useFacebookPixel } from "./useFacebookPixel";
import { useFetcher } from "@/api/utils";
import { GetStoreBankAccount } from "@/api/stores";
import { checkStoreIsOpen } from "@/assets/js/utils/utils";

const useStorefrontsInitializer = (store: StoreInterface, query: { [key: string]: string }) => {
  const [fullySetup, setFullySetup] = useState(false);
  const [selectedItem, setSelectedItem] = useState<ProductItemInterface | null>(null);

  useFacebookPixel(store?.configuration?.facebook_pixel_enabled ? store?.configuration?.fb_pixel : null);
  const { saveAnalytics } = useAnalytics(PAGE_TYPE.STORE, query?.ref);
  const { modals, toggleModal } = useModals([
    "explainer",
    "product_details",
    "search_modal",
    "about_store",
    "refund_policy",
    "delivery_fees",
    "more_info",
    "image_details",
    "faq",
    "categories",
    "about_images",
  ]);
  const fetchStoreBankAccountReq = useFetcher(GetStoreBankAccount, { id: store?.id });

  const maintenanceMode = store?.maintenance_mode ?? false;
  const storeIsOpen = checkStoreIsOpen(store);

  useEffect(() => {
    if (store) {
      window.COUNTRY = store.country;
      // setupCurrencySettings(store);

      if (store?.configuration?.color && isValidHexCode(store?.configuration?.color)) {
        const p = hexToRgb(store?.configuration?.color);
        const primaryRGB = `${p.r}, ${p.g}, ${p.b}`;
        document.documentElement.style.setProperty("--primary-500", primaryRGB);
        document.documentElement.style.setProperty("--discount-badge", primaryRGB);

        const s = hexToRgb(generateComplementaryHexColor3(store?.configuration?.color));
        const secondaryRGB = `${s.r}, ${s.g}, ${s.b}`;
        document.documentElement.style.setProperty("--accent-yellow-500", secondaryRGB);
        document.documentElement.style.setProperty("--add-to-cart", secondaryRGB);
        document.documentElement.style.setProperty("--success", secondaryRGB);
        document.documentElement.style.setProperty("--cart-badge", secondaryRGB);
      }

      setTimeout(() => {
        setFullySetup(true);
        saveAnalytics({ store: store?.id });
      }, 250);
    }
  }, []);

  const openItem = (item: ProductItemInterface) => {
    setSelectedItem(item);
    toggleModal("product_details");
  };

  const openItemFromModal = (item: ProductItemInterface) => {
    toggleModal("product_details");
    setSelectedItem(item);
    toggleModal("product_details");
  };

  return {
    fullySetup,
    modals,
    toggleModal,
    saveAnalytics,
    fetchStoreBankAccountReq,
    openItem,
    selectedItem,
    storeIsOpen,
    maintenanceMode,
    openItemFromModal,
  };
};

export default useStorefrontsInitializer;
